import { Component, OnInit } from "@angular/core";
import { ProductService } from "../../_services/product.service";
import { Router } from "@angular/router";
import { FlashMessagesService } from "angular2-flash-messages";
import { ConfirmationDialogComponent } from "../../shared/confirmation-dialog/confirmation-dialog.component";
import { MatDialog } from "@angular/material";
import { CommonService } from "../../_services/common.service";
import { AddQuickItemComponent } from "../add-quick-item/add-quick-item.component";


@Component({
  selector: 'app-quick-items',
  templateUrl: './quick-items.component.html',
  styleUrls: ['./quick-items.component.css']
})
export class QuickItemsComponent implements OnInit {

  public productLists: Array<any> = [];
  public loading = false;
  public total = 0;
  public pagesToShow = 10;
  public page = 1;
  public limit = 50;
  public search: string = '';
  public sortColumnName = 'name';
  public sortDirection = 'asc';
  public filterProductText: string = '';
  public filterBrandText: string = '';
  public brand_list: Array<any> = [];
  public showForm = false;
  public viewProductData: any = {};
  public productOptions: any = {};
  public quickItemImage: string = '';

  constructor(
    private ProductService: ProductService,
    private CommonService: CommonService,
    private router: Router,
    public dialog: MatDialog,
    private _flashMessagesService: FlashMessagesService
  ) {
    
  }

  ngOnInit() {
    this.getProducts();
    this.getBrandList(['quickItem', 'ssactivewear']);
  }  

  productThumb(img) {
    return img ? img : this.quickItemImage;
  }

  getProducts = function () {
    this.loading = true;
    this.productOptions = { limit: this.limit, page: this.page, provider: 'quickItem' };
    if (this.filterProductText) {
      this.productOptions.search = this.filterProductText;
    }
    if (this.filterBrandText) {
      this.productOptions.brand_id = this.filterBrandText;
    }
    if (this.sortDirection) {
      this.productOptions.direction = this.sortDirection;
    }
    this.productOptions.is_admin=true;
    this.ProductService.getProducts(this.productOptions).subscribe(
      (response: any) => {
        this.loading = false;
        if (response.status === true) {
          this.productLists = response.data.records.length > 0 ? response.data.records : [];
          this.total = response.data.total;
          this.current_page = response.data.current_page;

          this.limit = response.data.limit;
          this.quickItemImage = response.data.quickItemImage;
        }
      },
      err => {
        this.loading = false;
        console.log(err);
      }
    );
  };

  getBrandList = function (providers) {
    providers.forEach(provider => {
      let data = {
        id: localStorage.getItem("userID"),
        provider: provider,
        limit: 500
      };
      this.CommonService.apiService(
        "POST",
        "brands",
        data
      ).subscribe(
        (response: any) => {
          let totalRecords = response.data.records.length;
          if (response.status === true) {
            if (totalRecords > 0) {
              for (var i in response.data.records) {
                this.brand_list.push(response.data.records[i]);
              }
            }
          }
        },
        err => { }
      );
    });
  };

  filterProduct(): void {
    this.page = 1;
    this.total = 0;
    this.getProducts();
  }

  clearFilterProduct(): void {
    this.filterProductText = '';
    this.page = 1;
    this.total = 0;
    this.getProducts();
  }

  goToPage(n: number): void {
    this.page = n;
    this.getProducts();
  }

  onNext(): void {
    this.page++;
    this.getProducts();
  }

  onPrev(): void {
    this.page--;
    this.getProducts();
  }

  goSort($event) {
    this.sortColumnName = $event.columnName;
    this.sortDirection = $event.sortDirection;
    this.getProducts();
  }

  editProduct(productId){
    this.router.navigate(['/products/edit-quick-item', productId]);
  }

  openDeleteDialog(id: number): void {   
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: "250px",
      data: {
        name: "Admin",
        message: "Are you sure you want to delete this quick item",
        manageData: { product_id: id }
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.product_id) {
        this.deleteProduct(result.product_id);
      }
    });
  }

  deleteProduct = function (product_id) { 
    this.loading = true; 
    this.clientOptions = {};
    this.CommonService.apiService(
      "DELETE",
      "product/delete/"+product_id +"/" +localStorage.getItem("userID") ,
      this.clientOptions
    ).subscribe(
      (response: any) => {
        this.loading = false;
        if (response.status === true) {         
          this._flashMessagesService.show("Quick Item deleted successfully!", {
            cssClass: "alert-success",
            timeout: 5000
          });
          this.getProducts();
        }
        
      },
      err => {
        this.loading = false;
        this._flashMessagesService.show(err.error.message, {
          cssClass: "alert-danger",
          timeout: 5000
        });
        window.scrollTo(0, 0);  

      }
    );
  };

  duplicateProduct = function (product_id) {
    this.loading = true;
    this.options = {
      id: localStorage.getItem("userID"),
      product_id: product_id,
    };
    this.CommonService.apiService(
      "POST",
      "product/duplicate",
      this.options
    ).subscribe(
      (response: any) => {
        this.loading = false;
        if (response.status === true) {
          this._flashMessagesService.show("Quick Item successfully duplicated!", {
            cssClass: "alert-success",
            timeout: 5000
          });
          this.getProducts();
        }
      },
      err => {
        this.loading = false;
        this._flashMessagesService.show(err.error.message, {
          cssClass: "alert-danger",
          timeout: 5000
        });
        window.scrollTo(0, 0);

      }
    );
  };

  createQuickItem(): void {
    const dialogRef = this.dialog.open(AddQuickItemComponent, {
      width: "90%",
      maxWidth: "none",
      disableClose: true,
      data: {}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result.productId) {
        this.getProducts();
      }
    });
  }

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-products/quick-items/quick-items.component.ts